import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { API_BASE_URL } from "./constants";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export class ResponseError extends Error {
  statusCode: number;

  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
}

export const lensburyFetch = async (method: string, endpoint: string, body?: any) => {
  const headers = new Headers();
  headers.set("Accept", "application/json");
  if (body) {
    headers.set("Content-Type", "application/json");
  }
  if (body) {
    body = JSON.stringify(body);
  }
  const res = await fetch(API_BASE_URL + endpoint, { method, body, headers, credentials: "include" });
  let data;
  if (res.headers.get("Content-Type") == "application/json") {
    data = await res.json();
  }
  if (!res.ok) {
    throw new ResponseError(data?.error ?? "An error occurred", res.status);
  }
  return data;
}
